import { useSelector } from "react-redux";
import styles from "./NetworkAlert.module.scss";

const COPY = {
  loading: {
    title: "네트워크 연결 중",
    text: "네트워크 연결 중입니다.\n잠시만 기다려주세요",
  },
  connecting: {
    title: "네트워크 연결 시도 중",
    text: "네트워크 연결 상태가 불안정하여 검사가 중단되었습니다.\n잠시만 기다려주세요.",
  },
  disconnect: {
    title: "네트워크 끊김",
    text: "감독관과 연결이 중단되었습니다.\n시스템 종료 후 재접속해주세요.",
  },
};

const resolveState = ({ browserOnline, socketStatus }) => {
  if (socketStatus === "reconnect_failed") return "disconnect";
  if (
    !browserOnline ||
    socketStatus === "disconnected" ||
    socketStatus === "connect_error" ||
    socketStatus === "reconnecting"
  ) {
    return "connecting";
  }
  if (socketStatus === "loading") return "loading";
  return null;
};

const InfoIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="10" stroke="#2563eb" strokeWidth="2" />
    <path
      d="M12 8v4M12 16h.01"
      stroke="#2563eb"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const DangerIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 3 2 21h20L12 3z"
      stroke="#b91c1c"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M12 10v4M12 18h.01"
      stroke="#b91c1c"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const NetworkAlert = () => {
  const networkState = useSelector((state) => state.networkState) || {};
  const view = resolveState(networkState);

  if (!view) return null;

  const { title, text } = COPY[view];

  const iconNode = (() => {
    if (view === "loading" || view === "connecting") {
      return <div className={styles.spinner} />;
    }
    return <DangerIcon />;
  })();

  const iconWrapClass = (() => {
    if (view === "loading") return `${styles.iconWrap} ${styles.iconWrapInfo}`;
    if (view === "connecting")
      return `${styles.iconWrap} ${styles.iconWrapWarning}`;
    return styles.iconWrap;
  })();

  return (
    <div role="alertdialog" aria-modal="true" className={styles.overlay}>
      <div className={styles.card}>
        <div className={iconWrapClass}>{iconNode}</div>
        <h2
          className={`${styles.title} ${
            view === "disconnect" ? styles.titleDanger : ""
          }`}
        >
          {title}
        </h2>
        <p className={styles.text}>{text}</p>
        <div className={styles.support}>
          <span className={styles.supportLabel}>문제가 지속되면 아래번호로 문의주시기 바랍니다.</span>
          <a className={styles.supportPhone} href="tel:0254495222">
            02-549-5222
          </a>
        </div>
      </div>
    </div>
  );
};

export default NetworkAlert;
